import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  order?: { name_spec: string };
};

const NameSpecCell = React.memo((row: KpiWorkunitGridData) => (
  <>
    {row?.order?.name_spec && (
      <Tooltip title={row.order.name_spec}>
        <Typography variant="body2" noWrap>
          {row.order.name_spec}
        </Typography>
      </Tooltip>
    )}
  </>
));

export default NameSpecCell;
